__turbopack_context__.v({
  "app-side-padding": "Reviews-module-scss-module__FmKjgG__app-side-padding",
  "apply-possible-content-wrapper": "Reviews-module-scss-module__FmKjgG__apply-possible-content-wrapper",
  "bznav-main": "Reviews-module-scss-module__FmKjgG__bznav-main",
  "cornflower-500": "Reviews-module-scss-module__FmKjgG__cornflower-500",
  "customer_review_video_card": "Reviews-module-scss-module__FmKjgG__customer_review_video_card",
  "cyan-700": "Reviews-module-scss-module__FmKjgG__cyan-700",
  "fullcare-main": "Reviews-module-scss-module__FmKjgG__fullcare-main",
  "fullcare-sub": "Reviews-module-scss-module__FmKjgG__fullcare-sub",
  "heading-1": "Reviews-module-scss-module__FmKjgG__heading-1",
  "heading-2": "Reviews-module-scss-module__FmKjgG__heading-2",
  "heading-3": "Reviews-module-scss-module__FmKjgG__heading-3",
  "heading-4": "Reviews-module-scss-module__FmKjgG__heading-4",
  "heading-5": "Reviews-module-scss-module__FmKjgG__heading-5",
  "heading-6": "Reviews-module-scss-module__FmKjgG__heading-6",
  "heading-7": "Reviews-module-scss-module__FmKjgG__heading-7",
  "heading-8": "Reviews-module-scss-module__FmKjgG__heading-8",
  "highlight-gradient": "Reviews-module-scss-module__FmKjgG__highlight-gradient",
  "image": "Reviews-module-scss-module__FmKjgG__image",
  "lookup-result-layout": "Reviews-module-scss-module__FmKjgG__lookup-result-layout",
  "notice-container": "Reviews-module-scss-module__FmKjgG__notice-container",
  "paragraph-0": "Reviews-module-scss-module__FmKjgG__paragraph-0",
  "paragraph-1": "Reviews-module-scss-module__FmKjgG__paragraph-1",
  "paragraph-2": "Reviews-module-scss-module__FmKjgG__paragraph-2",
  "paragraph-3": "Reviews-module-scss-module__FmKjgG__paragraph-3",
  "paragraph-4": "Reviews-module-scss-module__FmKjgG__paragraph-4",
  "paragraph-5": "Reviews-module-scss-module__FmKjgG__paragraph-5",
  "paragraph-6": "Reviews-module-scss-module__FmKjgG__paragraph-6",
  "paragraph-7": "Reviews-module-scss-module__FmKjgG__paragraph-7",
  "paragraph-8": "Reviews-module-scss-module__FmKjgG__paragraph-8",
  "play_button": "Reviews-module-scss-module__FmKjgG__play_button",
  "play_button_wrapper": "Reviews-module-scss-module__FmKjgG__play_button_wrapper",
  "radial": "Reviews-module-scss-module__FmKjgG__radial",
  "refund-hero": "Reviews-module-scss-module__FmKjgG__refund-hero",
  "refund-investor": "Reviews-module-scss-module__FmKjgG__refund-investor",
  "refund-main": "Reviews-module-scss-module__FmKjgG__refund-main",
  "refund-sub": "Reviews-module-scss-module__FmKjgG__refund-sub",
  "review_item_card": "Reviews-module-scss-module__FmKjgG__review_item_card",
  "reviews_columns": "Reviews-module-scss-module__FmKjgG__reviews_columns",
  "reviews_divider": "Reviews-module-scss-module__FmKjgG__reviews_divider",
  "reviews_main_video_play_button": "Reviews-module-scss-module__FmKjgG__reviews_main_video_play_button",
  "shimmer": "Reviews-module-scss-module__FmKjgG__shimmer",
  "text_reviews_wrapper": "Reviews-module-scss-module__FmKjgG__text_reviews_wrapper",
  "text_wrapper": "Reviews-module-scss-module__FmKjgG__text_wrapper",
  "trace-in": "Reviews-module-scss-module__FmKjgG__trace-in",
  "trace-out": "Reviews-module-scss-module__FmKjgG__trace-out",
  "underline-swipe-in": "Reviews-module-scss-module__FmKjgG__underline-swipe-in",
  "video_card_thumbnail": "Reviews-module-scss-module__FmKjgG__video_card_thumbnail",
  "violet-500": "Reviews-module-scss-module__FmKjgG__violet-500",
});
